export default "__VITE_ASSET__DTgWSiu4__"